<template>
  <section v-if="languages?.length" class="languages pe-section">
    <h3>
      Languages
      <SectionActions
        v-show="isPowerEdit"
        class="actions"
        section="languages"
      />
    </h3>
    <section class="list">
      <template v-for="(lang, index) in languages" :key="lang.language">
        <section v-if="lang.language" class="language">
          <ItemActions
            v-show="isPowerEdit"
            class="itemActions"
            :index="index"
            section="languages"
            :uuid="lang.uuid"
            :actions="['delete']"
          />
          <span
            v-editable="isPowerEdit"
            :data-target-path="`resume.languages.${index}.language`"
            class="name"
            v-text="lang.language"
          ></span>
          <span class="fluency" v-if="lang.fluency">
            <span> (</span>
            <span
              v-editable="isPowerEdit"
              :data-target-path="`resume.languages.${index}.fluency`"
              v-text="lang.fluency"
            ></span>
            <span>)</span>
          </span>
        </section>
      </template>
    </section>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { Resume } from '@/types/resume/v1'
import { useStructuredResumeStore } from '@/store/pinia/structuredResume'
import SectionActions from './SectionActions.vue'
import ItemActions from './ItemActions.vue'

export default defineComponent({
  name: 'Languages',
  components: {
    SectionActions,
    ItemActions,
  },
  props: {
    languages: {
      type: Object as PropType<Resume.Language[]>,
      required: false,
    },
  },
  setup() {
    const store = useStructuredResumeStore()

    return { isPowerEdit: store.isPowerEdit }
  },
})
</script>

<style lang="postcss" scoped>
.languages {
  @apply pt-6-em;
  h3 {
    @apply leading-none text-xl-em flex items-center;
    .actions {
      @apply hidden;
    }
    &:hover {
      .actions {
        @apply flex;
      }
    }
  }
  .list {
    @apply mt-4-em @container;
    .language {
      @apply relative;
      .itemActions {
        @apply hidden;
      }
      &:hover {
        .itemActions {
          @apply flex;
        }
      }
      @container (min-width: 24em) {
        @apply inline-block mr-2;
        &:not(:last-child) {
          &:after {
            content: ',';
          }
        }
      }
      .name {
        @apply font-semibold;
      }
      .fluency {
        @apply italic mb-2-em text-sm-em;
      }
    }
  }
}
</style>
